<!--折线图配置 -->
<template>
  <div>
    <el-collapse accordion>
      <el-collapse-item title="折线设置">
        <Color :prop="main.activeOption"></Color>
        <el-form-item label="线条类型">
          <el-switch v-model="main.activeOption.smooth" active-text="曲线" inactive-text="直线" size="small">
          </el-switch>
        </el-form-item>
        <el-form-item label="线条宽度">
          <el-input-number v-model="main.activeOption.lineWidth" :min="1" :max="30" controls-position="right"
                           size="small"/>
        </el-form-item>
        <el-form-item label="显示标记点">
          <el-switch v-model="main.activeOption.symbolShow" size="small">
          </el-switch>
        </el-form-item>
        <el-form-item label="标记点直径" v-if="main.activeOption.symbolShow">
          <el-input-number v-model="main.activeOption.symbolSize" :min="1" :max="50" controls-position="right"
                           size="small"/>
        </el-form-item>
        <el-form-item label="标记点形状" v-if="main.activeOption.symbolShow">
          <el-select v-model="main.activeOption.symbolKind" class="m-2" size="small">
            <el-option v-for="(item, index) in symbolKind" :key="index" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="显示面积">
          <el-switch v-model="main.activeOption.areaStyle" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="线面颜色一致" v-if="main.activeOption.areaStyle">
          <el-switch v-model="main.activeOption.areaFollowLine" size="small"></el-switch>
        </el-form-item>
        <el-form-item label="面积颜色" v-if="main.activeOption.areaStyle && !main.activeOption.areaFollowLine">
          <singleColorTable v-model="main.activeOption.areaColor"></singleColorTable>
        </el-form-item>
        <el-form-item label="区域透明度" v-if="main.activeOption.areaStyle">
          <el-slider v-model="main.activeOption.areaOpacity" :max="1" :step="0.1">
          </el-slider>
        </el-form-item>
        <el-form-item label="线条个性化">
          <el-button type="primary" @click="showTool = true">配置</el-button>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>
    <el-dialog draggable v-model="showTool" title="线条个性化配置" align-center append-to-body width="1000">
      <LineSet ref="raderSet" v-if="showTool" :main="main" :additionConfig="['smooth']"></LineSet>
      <template v-slot:footer>
        <el-button @click="showTool = false">取消</el-button>
        <el-button type="primary" @click="handleOkClick">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Color from './commonSet/color.vue'
import {deepClone} from '@/echart/util'
import singleColorTable from './commonSet/single-color-table.vue'
import LineSet from './raderCustomSet.vue'

export default {
  name: 'line',
  inject: ["main"],
  components: {Color, singleColorTable, LineSet},
  data() {
    return {
      showTool: false,
      symbolKind: [{label: "默认", value: "emptyCircle"}, {label: "圆形", value: "circle"}, {
        label: "正方形",
        value: "rect"
      }, {label: "三角形", value: "triangle"}, {label: "菱形", value: "diamond"}, {label: "别针", value: "pin"}]
    }
  },
  methods: {
    rowSave(row, done) {
      if (!this.main.activeOption.areaColor) {
        this.main.activeOption.areaColor = []
      }
      this.main.activeOption.areaColor.push(deepClone(row));
      done()
    },
    rowDel(row, index) {
      this.main.activeOption.areaColor.splice(index, 1);
    },
    rowUpdate(row, index, done) {
      this.main.activeOption.areaColor.splice(index, 1, deepClone(row));
      done()
    },
    handleOkClick() {
      this.main.activeOption.lineCustomSet = this.$refs.raderSet.getSetting()
      this.showTool = false
    }
  }
}
</script>

<style></style>